export const SIGN_UP_REDIRECT_KEY = 'signUpRedirect';
export const SIGN_IN_REDIRECT_KEY = 'signInRedirect';
export const SELECTED_USER_ACCOUNT_KEY = 'selectedUserAccount';
